module.exports = __webpack_public_path__ + "img/review-us-on-google.f9343676.jpg";